<div class="container">
    <div class="row mt-4">
        <div class="col-12 text-center">
            <img height="100" [src]="imgMarca" alt="logo-marca">
        </div>
    </div>
    <div class="row mt-5">
        <div class="col-12">
            <nz-result nzStatus="success" [nzIcon]="imgMantenimiento" nzTitle="¡Estamos en mantenimiento!"
                [nzSubTitle]="subtitleFont">
            </nz-result>
        </div>
    </div>
</div>



<ng-template #imgMantenimiento>
    <img height="250" src="../../../../assets/images/mantainance.jpg" alt="img-mantenimiento">
</ng-template>

<ng-template #subtitleFont>
    <h5 class="text-center text-secondary">Estamos haciendo lo posible por mejorar tu experiencia, por favor vuelve en un momento.</h5>
</ng-template>